import { Typography } from "@material-ui/core";
import React, { Component } from "react";

class TickItem extends Component {
  render() {
    return (
      <div>
        <Typography variant="body1">
          <img
            src={this.props.image}
            style={{ verticalAlign: "middle", margin: "auto 1em auto auto" }}
          />
          <span>{this.props.text}</span>
        </Typography>
      </div>
    );
  }
}

export default TickItem;
